export default __webpack_public_path__ + "static/highlighter_tool_disabled.8b04a85c35eaec1cd52e2bbad1366199.svg";